import { ListItem } from 'components/Library';
import PropTypes from 'prop-types';
import { TEXT } from 'locales/translations';
import { ROUTES } from 'utils';
import { colors } from 'components/Theme';
import { Col, Container, Button, Row } from 'Common';
import { getColorSetByPrimaryColor } from 'utils/getColorSetByPrimaryColor';

const CourseTeaser = ({ category, course, buttonColor }) => {
  const suggested_courses = category.courses.filter((cs) => cs.id !== course.id).slice(0, 3);

  return (
    <section className="course-teaser">
      <Container>
        <Row>
          <Col xs={{ size: 12 }} className="d-flex justify-content-center">
            <h2 className="course-teaser__title mt-5">{TEXT.courseTeaser.headline}</h2>
          </Col>
        </Row>
        <Row className="d-flex justify-content-center">
          {suggested_courses.map((item, ix) => {
            return (
              <Col key={ix} xs={{ size: 12 }} lg={{ size: 4 }}>
                <ListItem
                  categoryBadge="noBadge"
                  newBadge={item.isNew ? 'new-badge' : 'no-badge'}
                  specialBadge={item.isSpecial ? 'special-badge' : 'no-badge'}
                  title={item.title}
                  time={Math.round(item.length / 60) + ' Min'}
                  type="course"
                  unitsCount={`${item.unitsCount} ${TEXT.library.units} |`}
                  color={item.backgroundColor}
                  illustration={item.pictureV2}
                  icon={item.locked ? 'locked-icon' : 'icon'}
                  slug={item.slug}
                />
              </Col>
            );
          })}
        </Row>
        <Row className="d-flex justify-content-center">
          <Col xs={{ size: 12 }} lg={{ size: 4 }}>
            <Button
              to={ROUTES.library}
              color={getColorSetByPrimaryColor(buttonColor).themeColor}
              className="w-100 mt-4 mt-lg-0"
            >
              {TEXT.courseTeaser.libraryButton}
            </Button>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

CourseTeaser.propTypes = {
  category: PropTypes.object.isRequired,
  course: PropTypes.object.isRequired,
  buttonColor: PropTypes.string.isRequired
};

CourseTeaser.defaultProps = {
  category: {},
  course: {},
  buttonColor: colors.green.c500
};

export default CourseTeaser;
